import React from 'react';
import { HeaderTitle, HeaderSubtitle } from '../../styles/checkoutStyles';

const CampaignHeader = ({ name, type }) => {
  return (
    <div>
      <HeaderTitle level={3}>{name}</HeaderTitle>
      <HeaderSubtitle>{type}</HeaderSubtitle>
    </div>
  );
};

export default CampaignHeader;
